import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-relatorio-laudo-veiculo",
  templateUrl: "./relatorio-laudo-veiculo.component.html",
  styleUrls: ["./relatorio-laudo-veiculo.component.scss"],
})
export class RelatorioLaudoVeiculoComponent implements OnInit {
  @Input() template;
  foto;
  parecer;
  parecerObs;
  textoPadrao: string = "";
  textoObservacao: string = "";
  observacaoInicial: string[] = [];
  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.template && this.template.elements) {
      this.parecer = this.template.elements.find((e) => e.name == "parecer");
      this.foto = this.template.elements.find(
        (e) => e.name == "frenteQuinaDireitaImg"
      );
      this.parecerObs = this.template.elements.find(
        (e) => e.name == "parecerObs"
      );

      //apresentação do texto padrao e do parecer
      this.template.elements.find(
        (e) => (this.textoPadrao = e.textoPadrao || "")
      );
      this.textoObservacao = this.parecerObs?.value || "";

      if (this.textoObservacao != "") {
        this.observacaoInicial = this.textoObservacao.split("¤¤");

        if (this.observacaoInicial.length > 1) {
          this.textoPadrao = this.observacaoInicial[0] || "";
          this.textoObservacao = this.observacaoInicial[1] || "";
        } else if (this.textoPadrao != "") {
          this.textoObservacao = this.textoObservacao.replace(
            this.textoPadrao,
            ""
          );
        }
      }

      this.textoObservacao = this.textoObservacao.replace("¤¤", "");
      this.textoPadrao = this.textoPadrao.replace("¤¤", "");
      //fim apresentação do texto padrao e do parecer

      this.template.elements = this.template.elements.filter(
        (e) => e.name != "parecer" && e.name != "parecerObs"
      );
    }
  }
}
